/**
 * ResendOtp - Resend OTP with countdown timer
 */
import React, { useState, useEffect, useCallback } from 'react';

const RESEND_DELAY = 60; // seconds

function ResendOtp({ onResend, disabled }) {
  const [countdown, setCountdown] = useState(RESEND_DELAY);
  const [isResending, setIsResending] = useState(false);
  
  useEffect(() => {
    if (countdown <= 0) return;
    
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
    
    return () => clearInterval(timer);
  }, [countdown]);
  
  const handleResend = useCallback(async () => {
    if (countdown > 0 || isResending) return;
    
    setIsResending(true);
    
    try {
      await onResend();
      setCountdown(RESEND_DELAY);
    } catch (error) {
      console.error('Resend OTP failed:', error);
    } finally {
      setIsResending(false);
    }
  }, [countdown, isResending, onResend]);
  
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
  
  const canResend = countdown <= 0 && !isResending && !disabled;
  
  return (
    <div className="text-center text-sm">
      {countdown > 0 ? (
        <p className="text-gray-500">
          Resend OTP in{' '}
          <span className="font-semibold text-[#004171]">
            {formatTime(countdown)}
          </span>
        </p>
      ) : (
        <button
          type="button"
          onClick={handleResend}
          disabled={!canResend}
          className={`
            font-semibold transition-colors
            ${canResend 
              ? 'text-[#004171] hover:text-[#003366] cursor-pointer' 
              : 'text-gray-400 cursor-not-allowed'
            }
          `}
        >
          {isResending ? (
            <span className="flex items-center justify-center gap-2">
              <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                <circle 
                  className="opacity-25" 
                  cx="12" cy="12" r="10" 
                  stroke="currentColor" 
                  strokeWidth="4" 
                  fill="none" 
                />
                <path 
                  className="opacity-75" 
                  fill="currentColor" 
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" 
                />
              </svg>
              Sending...
            </span>
          ) : (
            'Resend OTP'
          )}
        </button>
      )}
    </div>
  );
}

export default ResendOtp;
